import React from 'react';
import { Folder, ChevronRight } from 'lucide-react';

interface Props {
  label: string;
  sublabel?: string;
  onClick: () => void;
}

const FolderCard: React.FC<Props> = ({ label, sublabel, onClick }) => (
  <button
    onClick={onClick}
    className="group w-full sm:w-80 rounded-2xl border border-neutral-200 bg-white p-5 shadow-sm hover:shadow-md transition flex items-center gap-4"
  >
    <div className="rounded-xl border border-neutral-200 p-3">
      <Folder className="w-6 h-6" />
    </div>
    <div className="text-left">
      <div className="font-semibold">{label}</div>
      {sublabel && <div className="text-sm text-neutral-500">{sublabel}</div>}
    </div>
    <ChevronRight className="ml-auto opacity-0 group-hover:opacity-100 transition" />
  </button>
);

export default FolderCard;
